import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../common/Button';
import { isMobile, isDesktopResolution, isTablet } from '../../../../common/Helpers/index';
import { Body } from '../../../../common/Typography/index';
import { StyledVdsRow } from '../../../../common/styles';

const ContactInfoButton = (props) => {
  const { disabled, onClickContinue, buttonName, contactBtnText } = props;
  const mobileView = isMobile();
  return (
    <div className={`${mobileView ? 'marginTop48' : 'marginTop16'}`}>
      <Button primary size="large" width={isTablet() && !isDesktopResolution() ? '150px' : '100%'} disabled={disabled} onClick={onClickContinue}>
        {buttonName}
      </Button>
      <StyledVdsRow mTop="16px" mLeft="5px">
        <Body size="medium">{contactBtnText}</Body>
      </StyledVdsRow>
    </div>
  );
};

ContactInfoButton.propTypes = {
  onClickContinue: PropTypes.func,
  disabled: PropTypes.bool,
  buttonName: PropTypes.string,
  contactBtnText: PropTypes.string,
};

export default ContactInfoButton;
